import { render, staticRenderFns } from "./cityDistributionList.vue?vue&type=template&id=b05d0e76&scoped=true&"
import script from "./cityDistributionList.vue?vue&type=script&lang=js&"
export * from "./cityDistributionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05d0e76",
  null
  
)

component.options.__file = "cityDistributionList.vue"
export default component.exports